//Libs
import {
  ColDef,
  ITooltipParams,
  ValueFormatterParams,
} from "ag-grid-community";

//Local
import { convertFromCamelCaseToUpperCaseString } from "../../utils/convertFromCamelCaseToUpperCaseString";

// REFACTOR: ?
// use more than once??
export function getWRListTableCustomizedColumns(
  craftDetails: Record<string, any>,
) {
  const additionalColumnsSelection: Record<string, any> = {};
  const additionalColumns: ColDef[] = [];
  const workRecordTableColumnsDefaultValues: Record<string, boolean> = {
    thumbnailURL: true,
    title: true,
    numOpenTasks: true,
    createdBy: false,
    timestampRecordCreated: false,
  };

  if (craftDetails != null) {
    for (const workRecordTypeObj of Object.values(craftDetails)) {
      for (const [name, workRecordDetail] of Object.entries(
        workRecordTypeObj as Record<string, any>,
      )) {
        if (
          workRecordDetail.type === "string" ||
          workRecordDetail.type === "string-textarea"
        ) {
          if (
            !Object.keys(additionalColumnsSelection).includes(
              `craftDetails.${name}`,
            )
          ) {
            additionalColumnsSelection[`craftDetails.${name}`] = {
              value: false,
              title: workRecordDetail.title,
            };
            const column = {
              field: `craftDetails.${name}`,
              headerName: workRecordDetail.title,
              tooltipValueGetter: (params: ITooltipParams) =>
                params.valueFormatted ?? params.value,
              cellStyle: {
                height: "100%",
                display: "flex",
                alignItems: "center",
              },
            };
            additionalColumns.push(column);
          }
        }
        if (workRecordDetail.type === "selection") {
          if (
            !Object.keys(additionalColumnsSelection).includes(
              `craftDetails.${name}`,
            )
          ) {
            additionalColumnsSelection[`craftDetails.${name}`] = {
              value: false,
              title: workRecordDetail.title,
            };
            const column = {
              field: `craftDetails.${name}`,
              headerName: workRecordDetail.title,
              tooltipValueGetter: (params: ITooltipParams) =>
                params.valueFormatted ?? params.value,
              valueFormatter: (params: ValueFormatterParams) =>
                convertFromCamelCaseToUpperCaseString(params.value),
              cellStyle: {
                height: "100%",
                display: "flex",
                alignItems: "center",
              },
            };
            additionalColumns.push(column);
          }
        }
      }
    }
  }

  const extendedColumnDefaultValues = Object.keys(
    additionalColumnsSelection,
  ).reduce(
    (acc, columnName) => {
      return { ...acc, [`${columnName}`]: false };
    },
    { ...workRecordTableColumnsDefaultValues },
  );

  return {
    additionalColumnsSelection,
    additionalColumns,
    workRecordTableColumnsDefaultValues: extendedColumnDefaultValues,
  };
}
